import { useState, useEffect } from "react";
import { Gift, Sparkles, Clock, Check, X } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "../ui/button";

export default function TrialWelcomeModal() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [daysLeft, setDaysLeft] = useState(5);

  useEffect(() => {
    // عرض فقط للمستخدمين في التجربة المجانية ولأول مرة
    if (user?.license_type === "trial" && user?.trial_end_date) {
      const hasSeenWelcome = localStorage.getItem(`trial_welcome_${user.id}`);
      if (!hasSeenWelcome) {
        setShow(true);
        // حساب الأيام المتبقية
        const endDate = new Date(user.trial_end_date);
        const now = new Date();
        const diffTime = endDate - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        setDaysLeft(diffDays > 0 ? diffDays : 0);
      }
    }
  }, [user]);

  const handleClose = () => {
    localStorage.setItem(`trial_welcome_${user.id}`, "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" dir="rtl">
      <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in-up border border-white/10">
        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 p-6 text-center relative">
          <button
            onClick={handleClose}
            className="absolute top-3 left-3 p-1 hover:bg-white/20 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-white/80" />
          </button>
          <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-white/20 flex items-center justify-center">
            <Gift className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-1">مرحباً بك!</h2>
          <p className="text-emerald-100">لديك تجربة مجانية 5 أيام</p>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Days Counter */}
          <div className="bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30 rounded-xl p-4 text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Clock className="w-5 h-5 text-amber-400" />
              <span className="text-amber-400 font-bold">المدة المتبقية</span>
            </div>
            <p className="text-4xl font-bold text-white">{daysLeft} <span className="text-lg">أيام</span></p>
          </div>

          {/* Features */}
          <div className="space-y-2">
            <p className="text-slate-300 font-medium mb-3">استمتع بجميع الميزات مجاناً:</p>
            <div className="grid grid-cols-2 gap-2 text-sm">
              {[
                "نقطة البيع",
                "إدارة المخزون",
                "إدارة العملاء",
                "التقارير",
                "المصروفات",
                "الموردين",
                "الموظفين",
                "و المزيد..."
              ].map((feature, i) => (
                <div key={i} className="flex items-center gap-2 text-slate-300">
                  <Check className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Button */}
          <Button
            onClick={handleClose}
            className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-bold py-3 rounded-xl"
          >
            <Sparkles className="w-4 h-4 me-2" />
            ابدأ الآن
          </Button>
        </div>
      </div>
    </div>
  );
}
